<template>
  <modal
    title="Terms and Conditions and Privacy Policy"
    size="md"
    unclosable
    ref="modal">
    <q-scroll-area visible style="height: 500px">
      <div class="terms-privacy">
        <img src="../../assets/logo.png" />
        <terms-and-conditions />
        <privacy-policy class="q-mt-xl" />
      </div>
    </q-scroll-area>

    <q-separator />

    <p class="text-subtitle1 q-mt-md q-mb-none">
      To save a copy for your records, click <a href="https://private-footprint-prod.s3.ca-central-1.amazonaws.com/resources/docs/client/Terms+%26+Privacy.pdf" target="_blank">here</a>.
    </p>
    <template v-slot:actions>
      <async-btn
        :task="task"
        label="I have read and agree to the Terms and Conditions and Privacy Policy"
        color="positive"
        @click="agree"
      />
    </template>
  </modal>
</template>

<style lang="scss">
.terms-privacy {
  img {
    display: block;
    max-width: 15rem;
    margin: 1rem auto 2rem auto;
  }
  h4, h5 {
    margin-bottom: 1rem;
  }
  h4 {
    margin-top: 1rem;
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { agreeTerms } from '.';
import TermsAndConditions from './TermsAndConditions.vue';
import PrivacyPolicy from './PrivacyPolicy.vue';

interface Data {
  task: Promise<void>|null,
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    TermsAndConditions,
    PrivacyPolicy,
    AsyncBtn,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  methods: {
    agree() {
      this.task = agreeTerms(this.clientId);
      this.task.then(() => {
        this.$emit('ok');
        this.hide();
      });
    },
  },
});
</script>
